<template>
  <div class="frame">
    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />

    <!-- <div class="content"> -->
    <section class="cropper-area">
      <div class="img-cropper">
        <vue-cropper
          ref="cropper"
          :aspect-ratio="cropAspectRatio"
          :src="imgSrc"
          class="cropper"
        />
      </div>
      <div class="actions">
        <p style="font-size: 21px; margin:10px auto; line-height: 31px">
          Make your picture bigger or smaller until it fits in the frame - then
          click Go
        </p>
        <a href="#" role="button" @click.prevent="cropImage">
          Go
        </a>
        <a href="#" role="button" @click.prevent="reset">
          Reset
        </a>
        <a href="#" role="button" @click.prevent="showFileChooser">
          Upload Image
        </a>
      </div>
    </section>
    <!-- </div> -->
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "cropper",
  props: {
    cropAspectRatio: Number
  },
  components: {
    VueCropper
  },
  data() {
    return {
      imgSrc: "",
      cropImg: "",
      data: null
    };
  },
  methods: {
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg");
      this.$emit("childToParent", this.cropImg);
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute("data-scale", scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute("data-scale", scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.frame {
  background-color: rgb(152, 192, 215);
  border: 15px solid white;
  opacity: 0;
  animation: fi 0.5s ease-out forwards;
  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 250px;
    height: 50px;
    left: 50%;
    top: -8px;
    z-index: 1;
    background-repeat: no-repeat;
    transform: translate(-50%, -50%);
    background-image: url(../assets/module1/slide24/tape.png);
    background-size: contain;
    background-position: center;
  }
}

@keyframes fi {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

input[type="file"] {
  display: none;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 5px 0;
}
.header h2 {
  margin: 0;
}
.header a {
  text-decoration: none;
  color: black;
}
.actions {
  margin-top: 1rem;
  text-align: center;
  padding-left: 1rem;
  padding-right: 1rem;
}
.cropper {
  /* margin-top: 40px; */
  max-height: 500px;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062cc;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
  &:last-of-type {
    margin-right: 0;
  }
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  width: 307px;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
</style>
